import {Loader} from '@googlemaps/js-api-loader'
import {MarkerClusterer} from '@googlemaps/markerclusterer'

export function initMap(el) {
    const loader = new Loader({
        apiKey: 'AIzaSyCnAd_EkEhpfH_xPQ-ByQK0Atl5zQsJ8I8',
        version: 'weekly',
    });

    const places = JSON.parse(el.dataset.places);

    return loader.load().then(async () => {
        const {Map, InfoWindow} = await google.maps.importLibrary('maps');

        const map = new Map(el, {
            mapId: '133371ad7ff9fb19',
            zoom: 3,
            center: {lat: -28.024, lng: 140.887},
        });

        const infoWindow = new InfoWindow({
            content: '',
        });

        el.googleMap = map;
        el.googleMapInfoWindow = infoWindow;
        el.googleMapMarkerClusterer = new MarkerClusterer({ map, markers: [] })

        await setPlaces(places, el);
    });
}

export function showMap(btnEl, mapEl, dialog) {
    const url = dialog.get(0).dataset.loadPlacesUrl.replace('xxx', btnEl.dataset.placeGroupId);
    const loader = dialog.get(0).querySelector('[data-loading]');

    btnEl.addEventListener('click', (e) => {
        e.preventDefault();

        loader.style.display = 'block';
        mapEl.style.display = 'none';
        mapEl.googleMapMarkerClusterer.clearMarkers();

        dialog.modal('show');

        fetch(url, {
            cache: 'force-cache',
        })
            .then((response) => response.json())
            .then(async (json) => {
                mapEl.style.display = 'block';
                await setPlaces(json.places, mapEl);
            })
            .finally(() => {
                loader.style.display = 'none';
            })
    })
}

async function setPlaces(places, mapEl) {
    const {AdvancedMarkerElement} = await google.maps.importLibrary('marker');
    const {LatLngBounds} = await google.maps.importLibrary("core")

    const baseUrl = mapEl.dataset.placeDetailUrl.replace('xxx', '');

    const bounds = new LatLngBounds();

    const markers = places.map((pub) => {
        const pinImg = document.createElement('img');
        pinImg.src = '/images/icon.svg';
        const marker = new AdvancedMarkerElement({
            position: {lat: pub.gps_lat, lng: pub.gps_long},
            content: pinImg,
        });
        bounds.extend(marker.position);
        marker.addListener('click', () => {
            let content = '<div class="map-pub">';
            content += '<img src="' + pub.image_url + '" alt="' + pub.name_full + '" />'
            content += '<div class="description">';
            content += '<h3>' + pub.name + '</h3>'
            content += '<p>' + pub.street_full + '</p>'
            content += '<p>' + pub.city_name + '</p>'
            content += '<a class="btn btn-primary" href="' + baseUrl + pub.slug + '"><span>Zobrazit</span></a>'
            content += '</div>';
            content += '</div>';

            mapEl.googleMapInfoWindow.setContent(content);
            mapEl.googleMapInfoWindow.open(mapEl.googleMap, marker);
        })
        return marker;
    });

    mapEl.googleMapMarkerClusterer.addMarkers(markers);
    mapEl.googleMap.fitBounds(bounds);
}
